import { GroupViewItem } from 'configuration-schemas/viewdefns/general';
import { isEmpty } from 'lodash';
import { createSelector, type Selector } from 'reselect';
import { worklistLens } from 'src/services/lenses/lenses';
import { getDataToRender } from 'src/services/pivotServiceCache';
import type { AppState } from 'src/reducers';
import { externalGridSearchFields } from 'src/utils/Domain/Constants';
import { filterData } from 'src/utils/Pivot/Filter';
import type { Pivot } from 'src/worker/pivotWorker.types';

const getPivotData: Selector<AppState, Pivot> = (state) => {
  const worklist = worklistLens.get(state);
  return getDataToRender(worklist);
};

const getSearch: Selector<AppState, string> = (state) => {
  const worklist = worklistLens.get(state);
  return worklist.worklistSearch;
};

const getFlowStatus: Selector<AppState, number[]> = (state) => {
  const worklist = worklistLens.get(state);
  return worklist.worklistFlowStatus;
};

export const getWorklistViewDefnLevelBys: Selector<AppState, GroupViewItem[]> = (state) => {
  const worklist = worklistLens.get(state);
  return worklist.viewDefn?.companionView?.levelBy?.view ?? [];
};

export function getStyleData(styles: Pivot, search: string, flowStatus: number[]) {
  // add flowstatus to here
  const filteredStyles = !isEmpty(styles.flat)
    ? filterData(styles.flat, search, externalGridSearchFields, flowStatus)
    : [];
  const treeStyles = !isEmpty(styles.flat) ? filterData(styles.flat, search, externalGridSearchFields, flowStatus) : [];

  return {
    filteredStyles,
    treeStyles,
  };
}

export const getProcessedData = createSelector(getPivotData, getSearch, getFlowStatus, getStyleData);
